import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useWorkspaces } from "@/contexts/WorkspaceContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
  DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Smartphone, ChevronDown, Plus, Settings, Loader2, Check } from "lucide-react";

export default function WorkspaceSwitcher() {
  const { workspaces, active, max, loading, switchTo } = useWorkspaces();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  if (loading) {
    return (
      <div className="px-3 py-2 flex items-center gap-2 text-xs text-slate-400" data-testid="ws-switcher-loading">
        <Loader2 className="w-3 h-3 animate-spin" /> Cargando…
      </div>
    );
  }
  if (!active) return null;

  const remaining = Math.max(0, (max || 1) - workspaces.length);

  return (
    <div className="px-3 pt-3 pb-2">
      <DropdownMenu open={open} onOpenChange={setOpen}>
        <DropdownMenuTrigger asChild>
          <button
            className="w-full flex items-center gap-2 px-3 py-2 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 text-left transition"
            data-testid="ws-switcher-button"
          >
            <Smartphone className="w-4 h-4 text-emerald-400 shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-[10px] uppercase tracking-wider text-slate-400">WhatsApp activo</p>
              <p className="text-sm font-medium truncate text-white" data-testid="ws-switcher-active-name">{active.name}</p>
            </div>
            <ChevronDown className="w-4 h-4 text-slate-400 shrink-0" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-64" align="start" data-testid="ws-switcher-menu">
          <DropdownMenuLabel className="text-xs">
            Tus WhatsApps ({workspaces.length}/{max})
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          {workspaces.map((w) => (
            <DropdownMenuItem
              key={w.id}
              onClick={() => w.id !== active.id && switchTo(w.id)}
              className="flex items-center gap-2"
              data-testid={`ws-switcher-item-${w.id}`}
            >
              <Smartphone className="w-3.5 h-3.5 text-slate-500" />
              <span className="flex-1 truncate text-sm">{w.name}</span>
              {w.id === active.id && <Check className="w-3.5 h-3.5 text-emerald-500" />}
            </DropdownMenuItem>
          ))}
          <DropdownMenuSeparator />
          {remaining > 0 && (
            <DropdownMenuItem onClick={() => { setOpen(false); navigate("/dashboard/workspaces"); }} data-testid="ws-switcher-add">
              <Plus className="w-3.5 h-3.5 mr-2" /> Agregar nuevo WhatsApp
              <span className="ml-auto text-xs text-slate-400">{remaining} disp.</span>
            </DropdownMenuItem>
          )}
          <DropdownMenuItem onClick={() => { setOpen(false); navigate("/dashboard/workspaces"); }} data-testid="ws-switcher-manage">
            <Settings className="w-3.5 h-3.5 mr-2" /> Administrar
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
